import breakpoint from '@/client/components/theme/breakpoint'
import color from '@/client/components/theme/color'
import space from '@/client/components/theme/space'
import styled from 'styled-components'

export const Content = styled.div`
  padding: 3rem 0;
`

export const SearchSetup = styled.div`
  display: block;

  @media (min-width: ${breakpoint.lg2}) {
    display: none;
  }
`

export const Related = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -1rem;

  & .blog-meta-data-date {
    color: ${color.primary.pure};
  }
`

export const SingleBlogCard = styled.div`
  width: calc((100% / 1) - 2rem);
  margin: 2rem 1rem;

  @media (min-width: ${breakpoint.md}) {
    width: calc((100% / 3) - 2rem);
    margin: 2rem 1rem;
  }
`
